class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if( document.querySelector('.this__upsell_swiperWrapper') ){
      if( document.querySelector('.this__upsell_swiperWrapper').childElementCount == 0 ){ document.querySelector('.items__blocks__content.items__upsell_blocks').classList.add('hidden'); }
    }
    if ( this.querySelectorAll('.cart_empty_items_swiper.swiper').length > 0 ){
      this.swiperElementCardSwp = this.querySelector('.cart_empty_items_swiper.swiper');
      if (this.swiperElementCardSwp) {
        this.config = { spaceBetween: 18,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true } };
        if (!this.isIOS) {
          this.config.freeMode = true;
          this.config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        }
        new Swiper(this.swiperElementCardSwp, this.config);
      }  
    }
    if ( this.querySelectorAll('.this__upsell_swiper.swiper').length > 0 ){
      this.swiperElementUpsellSwp = this.querySelector('.this__upsell_swiper.swiper');
      if (this.swiperElementUpsellSwp) {
        this.configUpsell = { spaceBetween: 12,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true } };
        if (!this.isIOS) {
          this.configUpsell.freeMode = true;
          this.configUpsell.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        }
        new Swiper(this.swiperElementUpsellSwp, this.configUpsell);
      }  
    }

    if( this.querySelectorAll('[js-upgrade-item]').length > 0 ){
      this.querySelectorAll('[js-upgrade-item]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          this.enableLoading();
           let id_upgrade,id_qtySt,id_sell_id,id_key_url,id_updateProduct;
           id_upgrade = target.target.getAttribute('data-upgrade-variant-id');
           id_qtySt = target.target.getAttribute('upgrade-data-qty');
           id_sell_id = target.target.getAttribute('data-upgrade-selling-id');
           id_key_url = target.target.getAttribute('upgrade-data-line');
           id_updateProduct = {'items': [{'id': id_upgrade,'quantity': id_qtySt,'selling_plan':id_sell_id}]};
          fetch(id_key_url, {
            method: 'GET',
          }).then(response => {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(id_updateProduct)
            }).then((response) => response.text())
            .then((responseText) => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#cart-drawer__inner'); document.querySelector('#cart-drawer__inner').innerHTML = sourceQty.innerHTML;
                });
                fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
                .then((response) => response.text())
                .then((responseText) => {
                  const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
                });
            }).finally(() =>{ this.disableLoading() }).catch((e) => { console.error(e); });
          }).catch((error) => { console.error('Error:', error); });
        })
      })
    }

    if( this.querySelectorAll('[js-upsell-add-cart]').length > 0 ){
      this.querySelectorAll('[js-upsell-add-cart]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          this.enableLoading();
          let u_id,u_updateProduct;
           u_id = target.target.getAttribute('data-upsell-id');
           u_updateProduct = {'items': [{'id': u_id,'quantity': 1}]};
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(u_updateProduct)
          }).then((response) => response.text())
          .then((responseText) => {
             fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#cart-drawer__inner'); document.querySelector('#cart-drawer__inner').innerHTML = sourceQty.innerHTML;
              });
             fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
              .then((response) => response.text())
              .then((responseText) => {
                const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
              });
          }).finally(() =>{ this.disableLoading() }).catch((e) => { console.error(e); });          
        })
      })
    }
    if (isValidSession) {this.querySelector('.spend__welcome_offer').classList.remove('hidden')}
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    document.querySelector('.cart_drawer_main_wrapper').classList.add('active');
    document.querySelector('.page-overlay').classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    document.querySelector('.cart_drawer_main_wrapper').classList.remove('active');
    document.querySelector('.page-overlay').classList.remove('is-visible');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__inner',
        section: document.getElementById('cart-drawer__inner').dataset.id,
        selector: '#cart-drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: document.getElementById('cart-icon-bubble').dataset.id,
        selector: '.cart-icon-bubble'
      }
    ];
  }  

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.open();
      if( document.querySelector('.this__upsell_swiperWrapper') ){
        if( document.querySelector('.this__upsell_swiperWrapper').childElementCount == 0 ){ document.querySelector('.items__blocks__content.items__upsell_blocks').classList.add('hidden'); }
      }
    });
  }
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }  

  updateQuantity(line, quantity, name,updateData = null,action = null,itemData = null) {
      this.enableLoading(line);
      let body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      let fetchUrl = routes.cart_change_url;
      if(updateData != null && action == 'bundle'){
        let updates = [],
            keyQty = {},
            mainProductData = {
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            },
            splitData = updateData.split('=='),
            keys = splitData[0].split(','),
            mainProduct = splitData[1].split('|'),
            jsonItemData = JSON.parse(itemData);
        for (let key of keys) {
          let data = key.split('|'),
              tmp = {};
          tmp.id = data[0];
          tmp.quantity = (parseInt(data[1]) * quantity);
          updates.push(tmp);
          keyQty[data[0]] = (parseInt(data[1]) * quantity);
        }
        mainProductData.id = mainProduct[0];
        mainProductData.quantity = parseInt(quantity);
        mainProductData.properties = jsonItemData.properties;
        for (let index = 0; index < keys.length ; index++) {
          let splitData = keys[index].split('|');
          mainProductData.properties[`Product_${index + 1}`] = `${splitData[2]} | ${keyQty[splitData[0]]}`
        }
        this.bundleUpdateAction(mainProductData,updates);
      }else{
       this.fetchAction(fetchUrl,body); 
      }
  }  

  onChange(event) {
    if(event.target.value !== 'on') {
      if(event.target.closest('[data-bundle-items]')){
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name'),
          event.target.closest('[data-bundle-items]').dataset.bundleItems,
          'bundle',
          event.target.closest('[data-bundle-items]').querySelector('.item-data').innerText
        );
      }else{
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      }
    }
  }  
  
  async bundleUpdateAction(mainProductData,updates){
    for (let item of updates) {
      let body = JSON.stringify(item);
      const response = await fetch(routes.cart_change_url,{...fetchConfig(), ...{ body }});
      const data = await response.json();
    }
    this.fetchAction(routes.cart_change_url,JSON.stringify(mainProductData));
  }

  fetchAction(fetchUrl,body){
    fetch(`${fetchUrl}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
      }));
      this.disableLoading();  
    }).catch(() => {
      this.disableLoading();
    }).finally(() => {
      
    });
  }

  enableLoading() {
    if (!!document.getElementById('cart-drawer-loading')) {
     document.getElementById('cart-drawer-loading').classList.remove('hidden');
    }  
  } 
  
  disableLoading() {
    if (!!document.getElementById('cart-drawer-loading')) {
     document.getElementById('cart-drawer-loading').classList.add('hidden');
    }
  }  
  
  removeAll() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  }

  renderContent(sections){
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =  document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(sections[section.section], section.selector);
      
    }));
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if(this.closest('[data-bundle-items]')){
        this.closest('cart-drawer').updateQuantity(
          this.dataset.index,
          0,
          '',
          this.closest('[data-bundle-items]').dataset.bundleItems,
          'bundle',
          this.closest('[data-bundle-items]').querySelector('.item-data').innerText
        );
      }else{
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class QuantityInputCart extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
      this.closest('cart-drawer').updateQuantity(this.querySelector('.quantity__input').dataset.index, this.input.value);
  }
}

customElements.define("cus-quantity-input", QuantityInputCart);
